import React from 'react'
import * as styles from './_DropDownList.scss'
import {Form
  
} from 'react-bootstrap'
import PropTypes from 'prop-types';

class DropDownList extends React.Component {
  static propTypes = {
    id: PropTypes.string,
    listData: PropTypes.array.isRequired,
    label: PropTypes.string,
    message: PropTypes.string,
    handleChange: PropTypes.func,
    required: PropTypes.bool,
    disabled: PropTypes.bool,
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number
    ]).isRequired,
    isInvalid: PropTypes.bool,
    className: PropTypes.string
  }

  constructor (props) {
    super(props)
    this.handleChange = this.handleChange.bind(this)
  }

  handleChange (event) {
    this.props.handleChange(event.target.value)
  }

  render () {
    const {id, label, help, value} = this.props
    const controlLabelClasses = [styles['control-label'], this.props.required ? styles['required'] : null].filter(Boolean).join(' ')

    return (
      <Form.Group controlId={id} disabled={this.props.disabled} className={this.props.className} >
        {label && label.length > 0 ? <Form.Label className={controlLabelClasses}>{this.props.label}</Form.Label> : ''}
        <span className={styles['select-wrapper']}>
          <Form.Select className={styles['select-style']} value={value} onChange={this.handleChange} disabled={this.props.disabled} isInvalid={this.props.isInvalid}>
           {this.props.listData.map((item, index) => {
              return <option value={item.value} key={index}>{item.data}</option>
            })}
          </Form.Select>
        </span>
        {help && (
          <Form.Text className={styles['help-block-font-size']}>
            {help}
          </Form.Text>
        )}
        <Form.Control.Feedback type='invalid'>
          {this.props.message}
        </Form.Control.Feedback>
      </Form.Group>
    )
  }
}

export default (DropDownList)
